import React, { useEffect, useState } from 'react'
import ButtonStartIcon from '../../../../../button/ButtonStartIcon'
import Typography from '@mui/material/Typography'
import InputField from '../../../../../FormControl/input/InputField'
import Dialog from '../../../../../dialog/Dialog'
import { Alert } from '@mui/material'
import InputColor from '../../../../../FormControl/input/InputColor'
import { Switch } from '@mui/material'
import useCurriculumElementsStructure from '../../../../../../hooks/curriculum/useCurriculumElementsStructure'

const DialogElement = ({ 
  show, onClose, 
  type, data = {}, 
  setChange,
}) => {

  const types = ['add', 'edit', 'delete']
  const { 
    errors: errorsData,
    validateForm,
    updateBasicInformationElementStructure,
    updateTypeElementsElementStructure
  } = useCurriculumElementsStructure()
  const [form, setInputForm] = useState({})
  const [errors, setInputErrors] = useState(errorsData)
  const [loading, toggleLoading] = useState(false)

  const onChange = (name, value) => {
    setInputForm({ ...form, [name]: value })
    setInputErrors({ ...errors, [name]: null })
  }

  const onSave = async (e) => {
    if (!types.includes(type))  {
      setInputErrors({ message: 'Invalid type' })
      return
    }
    e.preventDefault()
    toggleLoading(true)
    try {
      let result = { error: false }
      const validation = validateForm(form)
        if (validation.error) {
          setInputErrors(validation)
          return
        }
      if (type === 'add') {
        result = await updateTypeElementsElementStructure(type, data.parent, data.childrenId, form);
      }

      if (type === 'edit') {
        if (data.parent) {
          result = await updateTypeElementsElementStructure(type, data.parent, form._id, form);
        } else {
          result = await updateBasicInformationElementStructure(form)
        }
      }
      if (type === 'delete') {
        if (data.parent) {
          result = await updateTypeElementsElementStructure(type, data.parent, form._id);
        } 
      }

      if (result.error) {
        setInputErrors(result)
      } else {
        onClose()
        setChange((old) => !old)
      }
    } finally {
      toggleLoading(false)
    }
  }

  useEffect(() => {
    setInputErrors(errorsData)
  }, [errorsData])

  useEffect(() => {
    if (data?.item) {
      setInputForm(data.item || {})
    }
  }, [data])

  const Actions = (
    <>
      <ButtonStartIcon
        onClick={onClose}
        color='primary'
        variant='outlined'
        disabled={loading}
        startIcon={["fal","times"]}
      >
        Cancel
      </ButtonStartIcon>
      { types.includes(type) &&
        <ButtonStartIcon
        onClick={onSave}
        color='primary'
        variant='contained'
        disabled={loading}
        loading={loading}
        startIcon={["fal","check"]}
      >
        { type === 'delete' ? 'Confirm' : 'Save'}
      </ButtonStartIcon>
      }
    </>
  );

  return (
    <Dialog
      id={`${type}-element`}
      show={show} 
      title={`${type} element`}
      onClose={onClose}
      actions={Actions}
    >
      { type === 'delete'
        ? <Typography>Are you sure you want to delete the element: <b>{form.name}</b>?</Typography>
        : <div className='flex flex-col gap-4 py-4'>
          <div className='grid grid-cols-4 items-start gap-4'>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Code
            </Typography>
            <div className='col-span-3'>
              { type === 'preview'
                ? <Typography>
                    {form.code}
                  </Typography>
                :  <InputField
                  id='code'
                  name='code'
                  value={form.code}
                  error={errors?.code}
                  helperText={errors?.code}
                  onChange={(e) => onChange("code", e.target.value)}
                  fullWidth
                />
              }
            </div>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Name
            </Typography>
            <div className='col-span-3'>
              { type === 'preview'
                ? <Typography>
                    {form.name}
                  </Typography>
                :  <InputField
                  id='name'
                  name='name'
                  value={form.name}
                  error={errors?.name}
                  helperText={errors?.name}
                  onChange={(e) => onChange("name", e.target.value)}
                  fullWidth
                />
              }
            </div>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Short Name
            </Typography>
            <div className='col-span-3'>
              { type === 'preview'
                ? <Typography>
                    {form.shortName}
                  </Typography>
                :  <InputField
                  id='shortName'
                  name='shortName'
                  value={form.shortName}
                  error={errors?.shortName}
                  helperText={errors?.shortName}
                  onChange={(e) => onChange("shortName", e.target.value)}
                  fullWidth
                />
              }
            </div>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Mandatory
            </Typography>
            <div className='col-span-3'>
              <Switch
                id='mandatory'
                color="primary"
                name="mandatory"
                checked={form?.mandatory || false}
                onChange={(e) => onChange("mandatory", e.target.checked)}
              />
            </div>
            <Typography variant='inherit' className='font-bold pl-2' color='primary' align='right' component='p'>
              Primary color
            </Typography>
            <div className='col-span-3'>
              <InputColor
                id='primaryColor'
                name='primaryColor'
                type="color"
                value={form.primaryColor}
                error={errors?.primaryColor}
                disabled={type === 'preview'}
                onChange={(value) => onChange("primaryColor", value)}
                fullWidth
              />
            </div>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Secondary color
            </Typography>
            <div className='col-span-3'>
              <InputColor
                id='secondaryColor'
                name='secondaryColor'
                type="color"
                value={form.secondaryColor}
                error={errors?.secondaryColor}
                disabled={type === 'preview'}
                onChange={(value) => onChange("secondaryColor", value)}
                fullWidth
              />
            </div>
          </div>
        </div>
      }
      { errors && errors.message && 
        <Alert 
          severity="error"
          onClose={() => setInputErrors({ message: null })}
        >
          {errors.message}
        </Alert> 
      }
    </Dialog>
  )
}

export default DialogElement